/*
  Contact.js: Contact Page with Get Involved Form Link
*/

import { FaPhone, FaEnvelope } from "react-icons/fa";
// import facebook_logo from "../assets/Facebook_Logo_Primary.png";
// import instagram_logo from "../assets/Instagram_Glyph_Black.png";

const Contact = () => {
  return (
    <section className="bg-gray-100 min-h-screen py-20 px-6 md:px-20 text-sky-950">
      <div className="contact max-w-7xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <ContactInfo />
          <GetInvolvedForm />
        </div>
      </div>
    </section>
  );
};

const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold text-sky-950">Contact Us</h1>
      <p className="text-base text-gray-700 leading-relaxed">
        We’re here to help! Reach out with questions, ideas, or feedback — we’d love to hear from you.
      </p>
      <div className="space-y-6">
        <ContactDetail
          icon={<FaPhone className="text-xl text-sky-950" />}
          text="+1 480-678-0796"
          link="tel:+14806780796"
        />
        <ContactDetail
          icon={<FaEnvelope className="text-xl text-sky-950" />}
          text="nisaandsabirfoundation@gmail.com"
          link="mailto:info@nisaandsabirfoundation.org"
        />
        {/* <div>
          <div className="flex space-x-4">
            <a href="https://facebook.com/yourpage" target="_blank" rel="noopener noreferrer">
              <img src={facebook_logo} alt="Facebook" className="h-8 w-8" />
            </a>
            <a href="https://instagram.com/yourpage" target="_blank" rel="noopener noreferrer">
              <img src={instagram_logo} alt="Instagram" className="h-8 w-8" />
            </a>
          </div>
        </div> */}
      </div>
    </div>
  );
};

const ContactDetail = ({ icon, text, link }) => (
  <div className="flex items-center space-x-4">
    {icon}
    {link ? (
      <a href={link} className="text-base text-gray-700 hover:underline">
        {text}
      </a>
    ) : (
      <p className="text-base text-gray-700">{text}</p>
    )}
  </div>
);

const GetInvolvedForm = () => (
  <div id="volunteer-form" className="text-center bg-gray-50 rounded-xl shadow-md p-6 sm:p-10 flex flex-col justify-center">
    <h2 className="text-3xl font-bold mb-4 text-sky-950">Want to Get Involved?</h2>
    <p className="text-gray-600 max-w-xl mx-auto mb-6">
      Ready to make a difference? Click the button below to get in touch with us.
    </p>
    <a
      href="https://docs.google.com/forms/d/e/1FAIpQLSeUsaDj3ov-pbEkeH7OKkuJW5KZ1mdjb3dm-yUQjElmB1OHpw/viewform?usp=dialog"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block bg-sky-950 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 shadow-lg transform hover:scale-105"
    >
      Fill Out the Form
    </a>
  </div>
);

export default Contact;
